export default "__VITE_ASSET__23ae2ad0__"